import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pinFilled"
const PinFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C16.556 1.5 20.25 4.78 20.25 9.75 20.25 15.75 13.375 22.5 12 22.5S3.75 15.75 3.75 9.75C3.75 4.78 7.444 1.5 12 1.5M12 6C9.929 6 8.25 7.679 8.25 9.75S9.929 13.5 12 13.5 15.75 11.821 15.75 9.75 14.071 6 12 6"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PinFilledIcon
